import * as React from 'react';

function ZezamiiLockersIcon({ color = '#545454', ...props }) {
	return (
		<svg width={18} height={18} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M14 14H14.01M10 6H14M10 10H14M8 2H16C17.1046 2 18 2.89543 18 4V20C18 21.1046 17.1046 22 16 22H8C6.89543 22 6 21.1046 6 20V4C6 2.89543 6.89543 2 8 2Z'
				stroke={color}
				stroke-width='2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<rect x='16.0391' y='0.994141' width='7.08392' height='7.64024' rx='1.5' fill={color} />
			<path
				d='M17.8292 6.99414V6.41918L20.1156 3.21101H17.8247V2.41232H21.3326V2.98729L19.044 6.19545H21.3371V6.99414H17.8292Z'
				fill={color === 'white' ? '#545454' : 'white'}
			/>
		</svg>
	);
}

export default ZezamiiLockersIcon;
